import { BackupRequestDTO } from "@/core/dto/deduction/remittance";
import { IBackupRequestRepository } from "@/core/repositories/remittance/backupRequest/IBackupRequest.repository";

export class RaiseBackupRequestUseCase {
  constructor(private readonly backupRequestRepository: IBackupRequestRepository) {}

  async execute(params: BackupRequestDTO) {
    const response = await this.backupRequestRepository.backupRequest(params);

    return response;
  }
}
